import { ReturnStatement } from '@angular/compiler';
import { Injectable } from '@angular/core';
import { FirebaseApp } from '@angular/fire/compat';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
// import * as firebase from 'firebase';

import { BehaviorSubject, Observable } from 'rxjs';
import { catchError, map, subscribeOn } from 'rxjs/operators';
import { NotificationType } from '../models/enums';
import { EventVM } from '../models/event/event';
import { ITicketItemGroup } from '../models/ticket/ticketItemGroup.interface';
import { CacheService } from './cache.service';
import { MessagingProviderService } from './providers/messaging.provider.service';
import { UserService } from './user.service';
import { ModelMapperService } from './util/model.mapper.service';
import { StorageService } from './util/storage.service';

@Injectable()
export class MessagingService {

  private currentMessage = new BehaviorSubject(null);
  private eventsIdsForNotification: string[] = [];
  private fbToken: string = null;

  constructor(
    private angularFireMessaging: AngularFireMessaging,
    private modelMapper: ModelMapperService,
    private messagingProvider: MessagingProviderService,
    private storage: StorageService,
    private cacheService: CacheService,
    private userService: UserService,
    private fa: FirebaseApp) {
      // commneted because notifications are not redy for deploy
    // this.userService.userLoggedInOut$.subscribe(isLogged => this.getEventsForSubscription(isLogged));
    this.angularFireMessaging.messages.subscribe(
      (_messaging: any) => {
        // console.log(_messaging);
        // this.showCustomNotification(messaging);
        // const notificationOptions = {
        //   body: 'Background Message body.'
        // };
        // navigator.serviceWorker.getRegistration('/firebase-cloud-messaging-push-scope').then(registration => {​​​​​ registration.showNotification('safasdf', notificationOptions); }​​​​​);

        // _messaging.onMessage = _messaging.onMessage.bind(_messaging);
        // _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
      });

    // const mess = firebase.messaging();

    // navigator.serviceWorker.getRegistration('/firebase-cloud-messaging-push-scope').then(registration => {​​​​​ registration.showNotification(payload.notification.title, NotificationOptions); }​​​​​);
    // this.messagingProvider.getUserEvents('101').subscribe(eventIds => {
    //   this.eventsIdsForNotification=eventIds;
    // });

  }

  public getFireBaseToken(): string{
    return this.fbToken;
  }

  getEventsForSubscription(isUserLogged: boolean) {
    if (isUserLogged) {
      if (this.cacheService.eventsForNotifications.length < 1) {
        this.messagingProvider.getUserEvents(+this.storage.userName).subscribe(eventIds => this.cacheService.eventsForNotifications = eventIds);
      }
    } else {
      this.cacheService.eventsForNotifications = [];
    }
  }

  requestPermission(): Observable<boolean> {
    console.log('MESSAGING SERVICE requestPermission');
    return this.angularFireMessaging.requestToken.pipe(
      map((token) => {
        this.fbToken = token;
        console.log('MESSAGING SERVICE dobavljanje tokena', token);
        if (this.fbToken) {
          return true;
        } else {
          console.log('nema tokena', token);
          return false;
        }
      }),
      catchError(
        (err) => {
          console.error('Unable to get permission to notify.', err);
          return [false];
        })
    );
  }

  public sendITicketItemGroupsForMessaging(ticketItemGroups: ITicketItemGroup[], receiveNotification: boolean) {
    // commneted because notifications are not redy for deploy
    return;
    if (receiveNotification) {
      return;
    }
    if (!this.fbToken) {
      // this.requestPermission().subscribe((hasPermission) => {
      //   if (hasPermission) {
      //     this.messagingProvider.sendEventsForNotification(this.modelMapper.mapFcmSubcriptionForTicketItemGroup(+this.storage.userName, this.fbToken, receiveNotification, iTicketItemGroup)).subscribe();
      //   }
      // });
      alert('Morate dozvoliti notifikacije da biste primali obavestenja');
    } else {
      this.messagingProvider.sendEventsForNotification(this.modelMapper.mapFcmSubcriptionForTicketItemGroup(+this.storage.userName, this.fbToken, receiveNotification, ticketItemGroups)).subscribe();
      for (const ticketItemGroup of ticketItemGroups) {
        this.cacheService.addEventToNotifications(ticketItemGroup.eventId);
      }
    }
  }

  public sendEventForMessaging(event: EventVM) {
    // commneted because notifications are not redy for deploy
    return;
    if (!event.isNotificationEnabled) {
      this.messagingProvider.sendEventsForNotification(this.modelMapper.mapFcmSubcriptionForEvent(+this.storage.userName, this.fbToken, event)).subscribe();
    } else {
      if (!this.fbToken) {
        // this.requestPermission().subscribe((hasPermission) => {
        //   if (hasPermission) {
        //     this.messagingProvider.sendEventsForNotification(this.modelMapper.mapFcmSubcriptionForEvent(+this.storage.userName, this.fbToken, event)).subscribe();
        //   } else {
        //     event.isNotificationEnabled = false;
        //   }
        // });
        alert('Morate dozvoliti notifikacije da biste primali obavestenja');
        event.isNotificationEnabled = false;
      } else {
        this.messagingProvider.sendEventsForNotification(this.modelMapper.mapFcmSubcriptionForEvent(+this.storage.userName, this.fbToken, event)).subscribe();
        this.cacheService.addEventToNotifications(event.id);
      }
    }
  }

  receiveMessage() {
    this.angularFireMessaging.messages.subscribe(
      (payload) => {
        console.log('new message received.', payload);
        this.currentMessage.next(payload);
        this.showCustomNotification(payload);
        return;
      });
  }

  showCustomNotification(payload: any) {
    const notifydata = payload.data;
    const event = JSON.parse(notifydata.event);

    const message = this.mapNotificationMessage(event);
    const options = {
      icon: 'assets/icons/admiral.png',
      body: message.body
    };
    // console.log('new message', notify_data);
    message.title = message.title;
    const notify: Notification = new Notification(message.title, options);
  }

  mapNotificationMessage(event: any) {
    const message = {
      title: '',
      body: ''
    };

    switch (event.sportId) {
      case 1: // football
        switch (event.notificationType) {
          case NotificationType.POINT:
            message.title = 'GOL ' + event.actor;
            message.body = event.eventName + ' ' + event.result;
            break;
          case NotificationType.PART_END:
            message.title = 'Poluvreme ' + event.eventName;
            message.body = 'Rezultat: ' + event.result;
            break;
          case NotificationType.MATCH_BEGIN:
            message.title = 'Početak utakmice ';
            message.body = event.eventName;
            break;
          case NotificationType.MATCH_END:
            message.title = 'Kraj utakmice ';
            message.body = event.eventName + ' ' + event.result;
            break;
          case NotificationType.RED_CARD:
            message.title = 'Crveni karton ' + event.actor;
            message.body = event.eventName + ' ' + event.result;
            break;
        }
        break;
      case 2: // basketball
        switch (event.notificationType) {
          case NotificationType.PART_END:
            message.title = 'Kraj' + event.part + 'četvrtine - ' + event.eventName;
            message.body = 'Rezultat: ' + event.result;
            break;
          case NotificationType.MATCH_BEGIN:
            message.title = 'Početak utakmice ';
            message.body = event.eventName;
            break;
          case NotificationType.MATCH_END:
            message.title = 'Kraj utakmice ';
            message.body = event.eventName + ' ' + event.result;
            break;
        }
        break;
      case 3: // tennis
        switch (event.notificationType) {
          case NotificationType.POINT:
            message.title = 'SET ' + event.actor;
            message.body = event.eventName + ' ' + event.result;
            break;
          case NotificationType.MATCH_BEGIN:
            message.title = 'Početak meča';
            message.body = event.eventName;
            break;
          case NotificationType.MATCH_END:
            message.title = 'Kraj meča';
            message.body = event.eventName + ' ' + event.result;
            break;
        }
        break;
      case 20: // volleyball
        switch (event.notificationType) {
          case NotificationType.POINT:
            message.title = 'SET ' + event.actor;
            message.body = event.eventName + ' ' + event.result;
            break;
          case NotificationType.MATCH_BEGIN:
            message.title = 'Početak meča';
            message.body = event.eventName;
            break;
          case NotificationType.MATCH_END:
            message.title = 'Kraj meča';
            message.body = event.eventName + ' ' + event.result;
            break;
        }
        break;
      case 25: // badmiton
        switch (event.notificationType) {
          case NotificationType.POINT:
            message.title = 'SET ' + event.actor;
            message.body = event.eventName + ' ' + event.result;
            break;
          case NotificationType.MATCH_BEGIN:
            message.title = 'Početak meča';
            message.body = event.eventName;
            break;
          case NotificationType.MATCH_END:
            message.title = 'Kraj meča';
            message.body = event.eventName + ' ' + event.result;
            break;
        }
        break;
      case 29: // beach soccer
        switch (event.notificationType) {
          case NotificationType.POINT:
            message.title = 'GOL ' + event.actor;
            message.body = event.eventName + ' ' + event.result;
            break;
          case NotificationType.PART_END:
            message.title = 'Poluvreme ' + event.eventName;
            message.body = 'Rezultat: ' + event.result;
            break;
          case NotificationType.MATCH_BEGIN:
            message.title = 'Početak utakmice ';
            message.body = event.eventName;
            break;
          case NotificationType.MATCH_END:
            message.title = 'Kraj utakmice ';
            message.body = event.eventName + ' ' + event.result;
            break;
          case NotificationType.RED_CARD:
            message.title = 'Crveni karton ' + event.actor;
            message.body = event.eventName + ' ' + event.result;
            break;
        }
        break;
      case 27: // beach volleyball
        switch (event.notificationType) {
          case NotificationType.POINT:
            message.title = 'SET ' + event.actor;
            message.body = event.eventName + ' ' + event.result;
            break;
          case NotificationType.MATCH_BEGIN:
            message.title = 'Početak meča';
            message.body = event.eventName;
            break;
          case NotificationType.MATCH_END:
            message.title = 'Kraj meča';
            message.body = event.eventName + ' ' + event.result;
            break;
        }
        break;
      case 29: // baseball
        switch (event.notificationType) {
          case NotificationType.MATCH_BEGIN:
            message.title = 'Početak meča';
            message.body = event.eventName;
            break;
          case NotificationType.MATCH_END:
            message.title = 'Kraj meča';
            message.body = event.eventName + ' ' + event.result;
            break;
        }
        break;
      case 7: // floorball
        switch (event.notificationType) {
          case NotificationType.PART_END:
            message.title = 'Kraj perioda' + event.eventName;
            message.body = 'Rezultat: ' + event.result;
            break;
          case NotificationType.MATCH_BEGIN:
            message.title = 'Početak meča';
            message.body = event.eventName;
            break;
          case NotificationType.MATCH_END:
            message.title = 'Kraj meča';
            message.body = event.eventName + ' ' + event.result;
            break;
        }
        break;
      case 9: // boxing
        switch (event.notificationType) {
          case NotificationType.MATCH_BEGIN:
            message.title = 'Početak meča';
            message.body = event.eventName;
            break;
          case NotificationType.MATCH_END:
            message.title = 'Kraj meča';
            message.body = event.eventName + ' ' + event.result;
            break;
        }
        break;
      case 24: // futsal
        switch (event.notificationType) {
          case NotificationType.POINT:
            message.title = 'GOL ' + event.actor;
            message.body = event.eventName + ' ' + event.result;
            break;
          case NotificationType.PART_END:
            message.title = 'Poluvreme ' + event.eventName;
            message.body = 'Rezultat: ' + event.result;
            break;
          case NotificationType.MATCH_BEGIN:
            message.title = 'Početak utakmice ';
            message.body = event.eventName;
            break;
          case NotificationType.MATCH_END:
            message.title = 'Kraj utakmice ';
            message.body = event.eventName + ' ' + event.result;
            break;
          case NotificationType.RED_CARD:
            message.title = 'Crveni karton ' + event.actor;
            message.body = event.eventName + ' ' + event.result;
            break;
        }
        break;
      case 6: // handball
        switch (event.notificationType) {
          case NotificationType.PART_END:
            message.title = 'Poluvreme ' + event.eventName;
            message.body = 'Rezultat: ' + event.result;
            break;
          case NotificationType.MATCH_BEGIN:
            message.title = 'Početak utakmice ';
            message.body = event.eventName;
            break;
          case NotificationType.MATCH_END:
            message.title = 'Kraj utakmice ';
            message.body = event.eventName + ' ' + event.result;
            break;
        }
        break;
      case 4: // hockey
        switch (event.notificationType) {
          case NotificationType.PART_END:
            message.title = 'Poluvreme ' + event.eventName;
            message.body = 'Rezultat: ' + event.result;
            break;
          case NotificationType.MATCH_BEGIN:
            message.title = 'Početak utakmice ';
            message.body = event.eventName;
            break;
          case NotificationType.MATCH_END:
            message.title = 'Kraj utakmice ';
            message.body = event.eventName + ' ' + event.result;
            break;
        }
        break;
      case 10: // MotoSport
        switch (event.notificationType) {
          case NotificationType.PART_END:
            message.title = 'Poluvreme ' + event.eventName;
            message.body = 'Rezultat: ' + event.result;
            break;
          case NotificationType.MATCH_BEGIN:
            message.title = 'Početak utakmice ';
            message.body = event.eventName;
            break;
          case NotificationType.MATCH_END:
            message.title = 'Kraj utakmice ';
            message.body = event.eventName + ' ' + event.result;
            break;
        }
        break;
      case 11: // Rugby
        switch (event.notificationType) {
          case NotificationType.PART_END:
            message.title = 'Poluvreme ' + event.eventName;
            message.body = 'Rezultat: ' + event.result;
            break;
          case NotificationType.MATCH_BEGIN:
            message.title = 'Početak utakmice ';
            message.body = event.eventName;
            break;
          case NotificationType.MATCH_END:
            message.title = 'Kraj utakmice ';
            message.body = event.eventName + ' ' + event.result;
            break;
        }
        break;
      case 17: // table tennis
        switch (event.notificationType) {
          case NotificationType.POINT:
            message.title = 'SET ' + event.actor;
            message.body = event.eventName + ' ' + event.result;
            break;
          case NotificationType.MATCH_BEGIN:
            message.title = 'Početak meča';
            message.body = event.eventName;
            break;
          case NotificationType.MATCH_END:
            message.title = 'Kraj meča';
            message.body = event.eventName + ' ' + event.result;
            break;
        }
        break;
      case 22: // Waterpolo
        switch (event.notificationType) {
          case NotificationType.PART_END:
            message.title = 'Poluvreme ' + event.eventName;
            message.body = 'Rezultat: ' + event.result;
            break;
          case NotificationType.MATCH_BEGIN:
            message.title = 'Početak utakmice ';
            message.body = event.eventName;
            break;
          case NotificationType.MATCH_END:
            message.title = 'Kraj utakmice ';
            message.body = event.eventName + ' ' + event.result;
            break;
        }
        break;
    }
    return message;
  }
}
